export const store = process.env.STORE
export const disableRegister = process.env.DISABLE_REGISTER
export const isB2BRegistrationEnabled =
  process.env.B2B_REGISTRATION_ENABLED === 'true'

export const DEBUG = '/confirmation?debug=true'

export const isDateToDate = process.env.STORE_TYPE === 'date_to_date'
export const isFlex = process.env.STORE_TYPE === 'subscription'
export const isClassicSub = process.env.STORE_TYPE === 'classic_subscription'
export const isSubscription = isFlex || isClassicSub
export const isB2B = process.env.B2B_ENABLED === 'true'
export const isDisplayBasketProductAvailableQuantity =
  process.env.DISPLAY_BASKET_PRODUCT_AVAILABLE_QUANTITY === 'true'
export const enableCustomerAccountId =
  process.env.ENABLE_CUSTOMER_ACCOUNT_ID === 'true'
export const SAVED_START_DATE = 'savedStartDate'
export const SAVED_END_DATE = 'savedEndDate'

export const enableHalfDay = process.env.ENABLE_HALF_DAY === 'true'

export const DATADOG_KEY = 'pube26c9972b5d28d5ea349653bf9915589'

export const PRICE_WITHOUT_DISCOUNT = 'price without discount'
export const DISCOUNTED_PRICE_ONLY = 'discounted price only'
export const DISCOUNTED_PRICE_WITH_DETAILS = 'discounted price with details'

export const minSubDuration = process.env.BRAND_MIN_SUB_DAYS

export const isLoginSSO = process.env.SSO_LOGIN
export const isSSO = process.env.SSO_TYPE !== undefined
/** Facturation gérée par le compte SSO Thermor : ne pas l’écraser via les PUT checkout. */
export const isThermorSSO = process.env.SSO_TYPE === 'thermor'

export const RMSDateFormat = 'YYYY-MM-DD'
export const SyliusDateFormat = 'DD/MM/YYYY'

export const byPassPayment =
  process.env.BYPASS_PAYMENT === 'true' ? true : false
export const byPassPassword = process.env.BYPASS_PASSWORD

export const ORDER_ITEM_TYPE = {
  RENTAL: 'RENTAL',
  PURCHASE: 'PURCHASE',
  TRYING: 'TRYING',
  SECOND_HAND: 'SECOND_HAND',
  MIXED: 'MIXED',
}

export const BY_PASS_TYPE = {
  CUSTOMER: 'CUSTOMER',
  OPERATOR: 'OPERATOR',
}

export const currentVersion = process.env.VERSION

export const secondHandCarrierId = process.env.CARRIER_ID

export const isSecondHandOnly = process.env.IS_SECOND_HAND_ONLY

export enum ORDER_STATE {
  CANCELLED = 'cancelled',
  COMING = 'coming',
  RETURN = 'return',
  FINISHED = 'finished',
}

export const enum PAYMENT_ACCORDION {
  CARD = 'card',
  PAYPAL = 'paypal',
}

export const LOCAL_STORAGE_KEYS = {
  CONNEXION_TYPE: 'connexion-type',
  TOKEN: 'TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  TOKEN_EXPIRE_AT: 'TOKEN_EXPIRE_AT',
  LOGIN_METHOD: 'LOGIN_METHOD',
  SSO_STATE: 'SSO_STATE',
  USER_TYPE: 'user-type',
}

export const SECOND_HAND_TAXON_SLUGS = [
  'second-hand',
  'seconde-main',
  'zwiter-hand',
  'b-ware',
  'Sale',
]

export const NEW_BUT_REPAIRED_TAXON_SLUG = 'b-ware'

export const GuideDesTaillesPageTitle = 'guide des tailles'

export const swiklyDepositPercentage = process.env.SWIKLY_DEPOSIT_PERCENTAGE

export const SWIKLY_API_BASE_URL =
  process.env.SWIKLY_API_URL ||
  (process.env.ENV === 'prod'
    ? 'https://api.v2.swikly.com/v1'
    : 'https://api.sandbox.swikly.com/v1')

export const show2ndHandWarehouseImagesFirst =
  process.env.SHOW_2ND_HAND_WAREHOUSE_IMAGES_FIRST === 'true'

export const simplifiedTakeBack = process.env.SIMPLIFIED_TAKE_BACK === 'true'
export const takeBackSelectedProduct = process.env.TAKE_BACK_SELECTED_PRODUCT
export const enableSearchFilterValuesFor =
  process.env.ENABLE_SEARCH_FILTER_VALUES_FOR?.split(',').map((item) =>
    item.toUpperCase()
  ) || []

export const displayTtcAndHtPrice = process.env.DISPLAY_TTC_PRICE === 'true'

export const customWarehouse = process.env.CUSTOM_WAREHOUSE ?? null

export const disableSecondHandSizeAndCondition =
  process.env.DISABLE_SECOND_HAND_SIZE_AND_CONDITION === 'true'

export const hidePricingOnGhostUser =
  process.env.HIDE_PRICING_ON_GHOST_USER === 'true'

export const hideSecondHandSizes = process.env.HIDE_SECOND_HAND_SIZES === 'true'

export const professionalAccountOnly =
  process.env.PROFESSIONAL_ACCOUNT_ONLY === 'true'

export const upcomingLocales = process.env.UPCOMING_LOCALES?.split(',') || []

export const hideBasketDeposit = process.env.HIDE_BASKET_DEPOSIT === 'true'

export const minimumCartItemsNotReached = 'MINIMUM_CART_ITEMS_NOT_REACHED'

export const disableQualityFilter =
  process.env.DISABLE_QUALITY_FILTER === 'true'

/**
 * Vaude only : codes de l'attribut SELECT (« Auswahl ») à sortir du dropdown de
 * filtres pour l'afficher en checkboxes à plat, sous les catégories et au-dessus
 * du premier filtre. Voir components/Filters/FilterDrawer.tsx.
 */
export const FLAT_TOP_FILTER_ATTRIBUTE_CODES =
  process.env.STORE === 'vaude' ? ['selection', 'auswahl'] : []

export const isWireTransferEnabled =
  process.env.IS_WIRE_TRANSFER_ENABLED === 'true'

export const enableProductCardReservation =
  process.env.ENABLE_PRODUCT_CARD_RESERVATION === 'true'

export const canChangeAccountInformation =
  process.env.CAN_CHANGE_ACCOUNT_INFORMATION !== 'false'

export const flipedAddressFields = process.env.FLIPPED_ADDRESS_FIELDS === 'true'

export const ssoLogoutRedirectUrl = process.env.SSO_LOGOUT_REDIRECT_URL

export const ssoErrorRedirectUrl = process.env.SSO_ERROR_REDIRECT_URL

export const shopProductFullImage =
  process.env.SHOP_PRODUCT_FULL_IMAGE === 'true'

export const imageFixInProductDetail =
  process.env.IMAGE_FIX_IN_PRODUCT_DETAIL === 'true'

/** Étape de checkout "Référence personnalisée" (B2B, ex. Groupe Atlantic) intercalée entre Livraison et Paiement. */
export const isOrderReferenceStepEnabled =
  process.env.ENABLE_ORDER_REFERENCE_STEP === 'true'

/** Champ "Raison sociale" (company) sur le formulaire d'adresse de livraison (B2B, ex. Groupe Atlantic). */
export const isShippingCompanyEnabled =
  process.env.ENABLE_SHIPPING_COMPANY === 'true'
